import { numberOfConsecutiveMovesAllowed } from "../configParams";

export const proofValidation = (
  test,
  arrOfConsecutiveMoves,
  isTestFinished
) => {
  const checked = document.getElementsByClassName("checked")[0];
  console.log(test, arrOfConsecutiveMoves);
  if (test.length > 0) {
    if (
      arrOfConsecutiveMoves.length > numberOfConsecutiveMovesAllowed &&
      test[0] === arrOfConsecutiveMoves[0]
    ) {
      test.shift();
      arrOfConsecutiveMoves.forEach((move) => {
        arrOfConsecutiveMoves.pop();
      });
      checked.style.animationName = "fadeIn";
    }
  } else {
    isTestFinished = true;
  }
  return isTestFinished;
};
